// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EduTextCard-module__wrapper___fmVRc","photo":"EduTextCard-module__photo___qK4nP","text":"EduTextCard-module__text___7Usvc"};